import styled from "styled-components";
import colors from "../../../../theme/color/ColorTheme";
import fontSize from "../../../../theme/fonts/FontTheme";
import { dateUtils } from "../../../../utils/DateUtils";
import StatusWrapper from "./StatusWrapper";

const Wrapper = styled.div`
  padding: 24px;
  border: 1px solid #004181;
  background-color: #e8f4ff;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 50%;
`;
const Details = styled.div`
  margin: auto 0px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;
const InfoSpan = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
`;
const Label = styled.span`
  font-size: ${fontSize.s};
  font-weight: 500;
  margin-right: 20px;
  color: ${colors.black};
`;

const Value = styled.span`
  font-size: ${fontSize.s};
`;
function OrderDeliveryInfo({ order }) {
  const details = [
    {
      label: "Shipping Address:",
      value: `${
        order.shippingAddress.address +
        ", " +
        order.shippingAddress.street +
        ", " +
        order.shippingAddress.city +
        ", " +
        order.shippingAddress.province
      }`,
    },
    { label: "Payment Method:", value: "Cash on Delivery" },
    {
      label: "Order Date:",
      value: `${dateUtils.toCombinedDate(order.createdAt)}`,
    },
    { label: "Contact Number:", value: `${order.customerDetails.phone}` },
  ];

  return (
    <Wrapper>
      <Details>
        {details.map((item) => (
          <InfoSpan key={item.label}>
            <Label>{item.label}</Label>
            <Value>{item.value}</Value>
          </InfoSpan>
        ))}
        <InfoSpan>
          <Label>Status</Label>
          <Value>
            <StatusWrapper status={order.status} />
          </Value>
        </InfoSpan>
      </Details>
    </Wrapper>
  );
}

export default OrderDeliveryInfo;
